import {PortExposureChunk} from "../../chunks/types/PortExposureChunk";
import {PortDirection} from "../types/PortDirection";
import {getPortDirectionFromPortExposureBodyChunk} from "./getPortDirectionFromPortExposureBodyChunk";

export function getPortDirectionFromPortExposureChunk(
  portExposureChunk: PortExposureChunk
): PortDirection {
  const {
    captures: {
      1: portExposureBodyChunk
    }
  } = portExposureChunk;
  return getPortDirectionFromPortExposureBodyChunk(portExposureBodyChunk)
}
